import { render } from "./ProjectRecurrence.vue?vue&type=template&id=52b3dd54"
import script from "./ProjectRecurrence.vue?vue&type=script&lang=js"
export * from "./ProjectRecurrence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__